export const setWsReponse = (action) => `SET_${action.replace(WS_PREFIX_OUT, '').split('/')[0]}`;

export const WS_PREFIX_OUT = 'WS_OUT:';
export const WS_PREFIX_IN = 'WS_IN:';
